import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function ErrorPage() {
  const navigate = useNavigate();
  const title="Page Not Found";
  const message="The requested Page is not available";
  const backurl="/";
  const buttonRef = React.useRef(null);

  useEffect(() => {
    setTimeout(() => {
      buttonRef.current?.click();
    }, 100);
  });

  const handleError = ()=>{
    //window.location=backurl;
    setTimeout(() => {
      navigate(backurl, { replace: true });
    }, 1000);
  }

  return (
      <>
<div type="button" data-bs-toggle="modal" data-bs-target="#myModal" ref={buttonRef}>
</div>

<div class="modal fade" id="myModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

          <div class="modal-header">
            <h4 class="modal-title">{title}</h4>
          </div>
          <div class="modal-body">
            {message}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal" onClick={handleError}>Ok</button>
          </div>

    </div>
  </div>
</div>
      </>
  );
}
  
